import { jsx as c } from "react/jsx-runtime";
import { SelectDropdown as L } from "../../atoms/SelectDropdown/SelectDropdown.es.js";
import { composeTrackId as s } from "../../utils/trackId.es.js";
const o = {
  AGENCY_LISTS: "agency-lists",
  MY_LISTS: "my-lists"
}, a = ({
  onChange: r,
  prefixTrackIds: t,
  selectedValue: S,
  ...l
}) => {
  const d = s(t, "list-dropdown"), n = [
    {
      label: "My Lists",
      value: o.MY_LISTS,
      onChange: r,
      trackId: s(t, `list-dropdown-${o.MY_LISTS}`)
    },
    {
      label: "Agency Lists",
      value: o.AGENCY_LISTS,
      onChange: r,
      trackId: s(t, `list-dropdown-${o.AGENCY_LISTS}`)
    }
  ];
  return /* @__PURE__ */ c(
    L,
    {
      options: n,
      defaultValue: S,
      trackId: d,
      ...l
    }
  );
};
export {
  o as LIST_DROPDOWN_VALUES,
  a as ListDropdown
};
//# sourceMappingURL=ListDropdown.es.js.map
